import Config from "services/config/config";
import callWebService, {
  callTypes
} from "services/utils/networks/network";
import {LOB_LIST, LOB_DROPDOWN, CREATE_LOB, EDIT_LOB} from "./type";

export const getLobListing = (filterData = null, page, id = null) => async (dispatch) => {
  try {
    let url = `${Config.lob.getLobListing}?page=${page}`;

    if (id) {
      url += `&id=${id}`;
    }

    if (filterData) {
      if (filterData.name) {
        url += `&name=${filterData.name}`;
      }
      if (filterData.dimension_value_type) {
        url += `&dimension_value_type=${filterData.dimension_value_type}`;
      }
      if (filterData.erp_code) {
        url += `&erp_code=${filterData.erp_code}`;
      }
    }

    const res = await callWebService(callTypes.get, {}, url);

    if (res) {
      const { data } = res;
      dispatch({
        type: LOB_LIST,
        payload: data.response.data,
      });
      return true;
    }
  } catch (error) {
    console.error("Error fetching LOB list:", error);
    return false;
  }
};

export const createLob = (data) => async (dispatch) => {

  try {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.lob.createLob
    );

    if (res?.data) {
      dispatch({
        type: CREATE_LOB,
        payload: res.data.response || {},
      });
    }

    return res || { status_code: 400, message: "Something went wrong" };
  } catch (error) {
    console.error("Error creating lob:", error);
    return { status_code: 400, message: error.message || "Something went wrong" };
  }

};

export const editLob = (data) => async (dispatch) => {

  try {
    const res = await callWebService(
      callTypes.patch,
      data,
      Config.lob.editLob
    );

    if (res?.data) {
      dispatch({
        type: EDIT_LOB,
        payload: res.data.response || {},
      });
    }

    return res || { status_code: 400, message: "Something went wrong" };
  } catch (error) {
    console.error("Error creating lob:", error);
    return { status_code: 400, message: error.message || "Something went wrong" };
  }

};